import { useTranslation } from 'react-i18next';
import { WifiOff } from 'lucide-react';
import { useNetworkStatus } from '@/shared/hooks/useNetworkStatus';

export function OfflineBanner() {
  const isOnline = useNetworkStatus();
  const { t } = useTranslation();

  if (isOnline) return null;

  return (
    <div className="fixed top-0 inset-x-0 z-[100] bg-amber-600 text-white px-4 py-2 text-center text-sm font-medium flex items-center justify-center gap-2">
      <WifiOff className="size-4" />
      {t('offline.message', 'You are offline. Some features may not work.')}
    </div>
  );
}
